import Svg, { Path } from 'react-native-svg'

export const BillIcon = ({ height = 20, width = 20, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M13.333 5.834h3.334a1.667 1.667 0 0 0-.492-1.175l-2.5-2.5a1.667 1.667 0 0 0-1.175-.492V5a.833.833 0 0 0 .833.834Zm-1.766.933A2.5 2.5 0 0 1 10.833 5V1.667H5.417A2.075 2.075 0 0 0 3.333 3.75v12.5a2.075 2.075 0 0 0 2.084 2.084h9.166a2.075 2.075 0 0 0 2.084-2.084V7.5h-3.334a2.5 2.5 0 0 1-1.766-.733Zm.1 4.9a2.5 2.5 0 0 1-.925 1.942l1.3.65a.833.833 0 0 1-.375 1.575.776.776 0 0 1-.375-.092l-3.334-1.667a.833.833 0 0 1 .375-1.575h.834a.834.834 0 0 0 0-1.666H7.5a.833.833 0 1 1 0-1.667h4.167a.833.833 0 0 1 0 1.667h-.15c.097.267.147.549.15.833Z"
      />
    </Svg>
  )
}
